import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getRecentVisits } from '../../utils/api-helper';

const initialState = {
  projectList: [],
  loading: false,
  error: null
};

export const fetchProjects = createAsyncThunk(
  'projects/fetchProjects',
  async () => {
    const response = await getRecentVisits(true);
    return response.data;
  }
);

export const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setProjectList: (state, action) => {
      state.projectList = action?.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjects.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjects.fulfilled, (state, action) => {
        state.loading = false;
        state.projectList = action.payload;
      })
      .addCase(fetchProjects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});
export const { setProjectList } = projectSlice?.actions;

export default projectSlice.reducer;
